import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,{attrs:{"to":_vm.to},on:{"click":_vm.onClick}},[_c(VListItemAvatar,[_c(VIcon,[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c(VListItemTitle,[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c(VListItemAction,[_c(VIcon,[_vm._v(" fal fa-arrow-right ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }